export const manifest = {
  screens: {
    scr_gy9b2a: { name: "Find the gap", route: "/", state: {"slideIndex":0}, position: {"x":160,"y":220} },
    scr_pr3m1s: { name: "The strategy lives in the gap", route: "/", state: {"slideIndex":1}, position: {"x":1560,"y":220} },
    scr_fr4m3w: { name: "Four steps in, two routes — usually both", route: "/", state: {"slideIndex":2}, position: {"x":160,"y":2200} },
    scr_cr1t3r: { name: "What decides the script", route: "/", state: {"slideIndex":3}, position: {"x":1560,"y":2200} },
    scr_hcpp3r: { name: "How HCPs rate the options today", route: "/", state: {"slideIndex":4}, position: {"x":2960,"y":2200} },
    scr_l3ofct: { name: "What LEO holds to be true", route: "/", state: {"slideIndex":5}, position: {"x":4360,"y":2200} },
    scr_w4rf4r: { name: "Warfare — prescription criteria", route: "/", state: {"slideIndex":6}, position: {"x":5760,"y":2200} },
    scr_g4pqnt: { name: "The gap, quantified", route: "/", state: {"slideIndex":7}, position: {"x":2960,"y":220} },
    scr_2r0ut3: { name: "Two routes out of the gap", route: "/", state: {"slideIndex":8}, position: {"x":160,"y":4180} },
  },
  sections: {
    sec_xgn961: { name: "Problem & Gap Analysis", x: 0, y: 0, width: 4320, height: 1180 },
    sec_11wotc: { name: "Current Landscape", x: 0, y: 1980, width: 7120, height: 1180 },
    sec_r02244: { name: "Routes & Strategy", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_dew4o4: { name: "Targeting & Execution", x: 0, y: 5940, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_xgn961", children: [
      { kind: "screen", id: "scr_gy9b2a" },
      { kind: "screen", id: "scr_pr3m1s" },
      { kind: "screen", id: "scr_g4pqnt" },
    ] },
    { kind: "section", id: "sec_11wotc", children: [
      { kind: "screen", id: "scr_fr4m3w" },
      { kind: "screen", id: "scr_cr1t3r" },
      { kind: "screen", id: "scr_hcpp3r" },
      { kind: "screen", id: "scr_l3ofct" },
      { kind: "screen", id: "scr_w4rf4r" },
    ] },
    { kind: "section", id: "sec_r02244", children: [
      { kind: "screen", id: "scr_2r0ut3" },
      { kind: "screen", id: "scr_3duc4t" },
    ] },
    { kind: "section", id: "sec_dew4o4", children: [
      { kind: "screen", id: "scr_t4rg3t" },
      { kind: "screen", id: "scr_m4tr1x" },
      { kind: "screen", id: "scr_n3xt8w" },
    ] },
  ],
}
